// composables/usePageTitle.ts
import type { MaybeRefOrGetter } from "vue";

interface PageMeta {
  title: MaybeRefOrGetter<string | undefined>;
  description?: MaybeRefOrGetter<string | undefined>;
  image?: MaybeRefOrGetter<string | undefined>;
}

export const usePageTitle = ({ title, description, image }: PageMeta) => {
  const siteName = "Pebble";
  const defaultDescription = "Pebble Web - Content Management System";

  const resolvedTitle = computed(() => {
    const t = toValue(title);
    return t ? `${siteName} | ${t}` : "Pebble Web";
  });

  const resolvedDescription = computed(() => {
    return toValue(description) || defaultDescription;
  });

  useHead({
    title: resolvedTitle,
    meta: [
      {
        key: "description",
        name: "description",
        content: resolvedDescription,
      },
      {
        key: "og:title",
        property: "og:title",
        content: resolvedTitle,
      },
      {
        key: "og:description",
        property: "og:description",
        content: resolvedDescription,
      },
    ],
  });
};
